<template>
  <MyModal
    title="机位排布"
    width="454px"
    height="auto"
    :style="{ top: '95px', left: '425px' }"
    @closeClick="handleCloseModalClick"
  >
    <!-- <el-tooltip
      effect="light"
      placement="right"
      class="el-icon-warning-outline desc-tooltip"
      popper-class="my-tooltip-right"
    >
      <div slot="content" class="desc-tooltip-con">
        <span> 鼠标选中可以进行风机调整</span>
      </div>
      <i class="el-icon-question"> </i>
    </el-tooltip> -->
    <div class="my-content">
      <div class="deploy-content" v-if="activeName === '自动布机'">
        <div class="row">
          <div
            :class="[
              'row-item',
              {
                place: item.place == 1,
                special: item.place == 2,
              },
            ]"
            v-for="(item, index) in rowItemList"
            :key="index"
          >
            <div class="row-item-core">
              <div class="key">{{ item.label }}</div>
              <div class="value">
                <StandInput
                  v-model="item.value"
                  :myType="item.type"
                  :onlyNumber="item.onlyNumber"
                  :unit="item.unit"
                  :interger="item.interger"
                  :max="item.max"
                  :min="item.min"
                  :selectOptions="item.selectOptions"
                  :multiple="item.multiple"
                  :readonly="item.readonly"
                  @change="(val) => changeCap(val, item)"
                ></StandInput>
              </div>
            </div>
          </div>
          <!-- <div class="row-item">
            <div class="row-item-core">
              <div class="key">高级设置</div>
              <div class="value">
                <div class="stand-switch-core">
                  <el-switch v-model="advanced" active-color="#6290F7">
                  </el-switch>
                </div>
              </div>
            </div>
          </div> -->
          <div v-if="advanced">
            <div
              :class="[
                'row-item',
                {
                  place: item.place == 1,
                },
              ]"
              v-for="(item, index) in seniorItemList"
              :key="index"
            >
              <div class="row-item-core">
                <div class="key">{{ item.label }}</div>
                <div class="value">
                  <StandInput
                    v-model="item.value"
                    :myType="item.type"
                    :onlyNumber="item.onlyNumber"
                    :unit="item.unit"
                    :interger="item.interger"
                    :max="item.max"
                    :min="item.min"
                    :selectOptions="item.selectOptions"
                    :multiple="item.multiple"
                    :readonly="item.readonly"
                    :icon="item.icon"
                    @change="(val) => changeCap(val, item)"
                  ></StandInput>
                </div>
                <!-- <el-tooltip
                  effect="light"
                  placement="right"
                  class="shear-tooltip"
                  popper-class="my-tooltip-right"
                  v-if="item.key === 'shear'"
                >
                  <div slot="content" class="shear-tooltip-con">
                    <span>说明: 切变值大于此值时，系统将自动推荐高塔筒</span>
                  </div>
                  <i class="el-icon-question"> </i>
                </el-tooltip> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="deploy-btn-wrapper" v-if="activeName === '自动布机'"  style="justify-content: center">
        <i
          class="el-icon-refresh refresh"
          :class="{ 'el-icon-refresh': !loading, 'el-icon-loading': loading }"
          @click="refreshCalc"
        ></i>
        <ct-button size="small" type="primary" :btnClick="handleDeployClick">自动排布</ct-button>
        <ct-button size="small" type="primary" :btnClick="handleImportClick">导入机位</ct-button>
        <el-popover
          placement="right"
          width="280"
          popper-class="popper"
          title="机位文件格式说明"
          trigger="click">
          <div class="popover-content">
            <p>机位文件接受csv格式。</p>
            <p>第一行为表头，表头下方为机位数据行。</p>
            <p>数据表前三列分别为：编号、经度、纬度。</p>
            <el-table size="mini" :data="gridData" style="margin:0 auto;width: 100%" border>
              <el-table-column property="turbineNo" label="编号" align="center"></el-table-column>
              <el-table-column property="lon" label="经度" align="center"></el-table-column>
              <el-table-column property="lat" label="纬度" align="center"></el-table-column>
            </el-table>
          </div>
          <i slot="reference" class="el-icon-question icon"></i>
        </el-popover>
      </div>

      <div style="border-top:1px solid #DCDFE6;padding:10px 0;display: flex;">
        <div style="padding-right:25px;">
          风机总数： {{ turbineList.length }}
          <i class="el-icon-add-location i-con" @click="handleAddFengji(true)"
             v-if="!toolUIStatus.fengji">增加</i>
          <template v-else>
            <i class="el-icon-check i-con" @click="handleSaceFengjiClick">保存</i>
            <i class="el-icon-close i-con" @click="cancelCreateFengji(false)">取消</i>
          </template>
        </div>
        <div>
          机型： {{ projectTurbineType }}
          <i class="el-icon-edit i-con" @click="ediProjectTurbineType()"
             v-if="!toolUIStatus.fengji">修改</i>
        </div>
      </div>
      <template v-if="turbineList.length">
        <el-table
          :data="turbineList"
          style="width: 100%"
          max-height="250px"
          row-class-name="table-row-class-name"
          size="mini"
          @row-click="rowClick"
        >
          <el-table-column prop="turbineNo" label="编号" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="lon" label="经度" header-align="center" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.inputLonName"
                v-if="scope.row.edit"
              />
              <span v-else>{{ scope.row.lon }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="lat" label="纬度" header-align="center" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.inputLatName"
                v-if="scope.row.edit"
              />

              <span v-else>{{ scope.row.lat }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <template v-if="!scope.row.edit">
                <el-button
                  @click="scope.row.edit = true"
                  type="text"
                  size="small"
                  >修改</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="deleteTurbineItem(scope.row)"
                  >删除</el-button
                >
              </template>
              <template v-if="scope.row.edit">
                <el-button
                  type="text"
                  size="small"
                  @click="updateTurbineItem(scope.row)"
                  >确定</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="scope.row.edit = false"
                  >取消</el-button
                >
              </template>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="deploy-btn-row deploy-btn-wrapper"
        >
          <div>
<!--            风机总数： {{ turbineList.length }}-->
<!--            <ct-button-->
<!--              type="primary"-->
<!--              size="small"-->
<!--              :btnClick="() => handleAddFengji(true)"-->
<!--              v-if="!toolUIStatus.fengji"-->
<!--              >增加</ct-button-->
<!--            >-->

<!--            <template v-else>-->
<!--              <ct-button size="small" :btnClick="handleSaceFengjiClick" type="primary"-->
<!--                >保存</ct-button-->
<!--              >-->
<!--              <ct-button-->
<!--                size="small"-->
<!--                :btnClick="-->
<!--                  () => {-->
<!--                    cancelCreateFengji(false);-->
<!--                  }-->
<!--                "-->
<!--                >取消</ct-button-->
<!--              >-->
<!--            </template>-->
          </div>
          <ct-button size="small" type="primary" :btnClick="handleExportTurbine">导出机位</ct-button>
        </div>
      </template>
    </div>

    <modal
      title="导入风机"
      width="500px"
      :visible.sync="showImportWindFarmDialog"
      @close="importDialogClose"
    >
      <div class="inner-wrapper">
        <el-form
          ref="form"
          :rules="uploadrules"
          :model="uploadForm"
          label-width="120px"
        >
          <el-form-item label="风机文件" prop="uploadFileName">
            <el-upload
              class="upload-demo"
              ref="upload"
              :with-credentials="true"
              :auto-upload="false"
              :action="action"
              :data="extraData"
              :on-change="handleUploadChange"
              :on-success="uploadSuccessCb"
              :on-error="uploadErrorCb"
              :file-list="fileList"
              :show-file-list="false"
            >
              <div class="click-area">
                <div class="file-name">{{ uploadForm.uploadFileName }}</div>
                <el-button type="text">上传</el-button>
              </div>
            </el-upload>
          </el-form-item>
        </el-form>

        <div class="my-btn-warpper">
          <ct-button :btnClick="handleTriImport" type="primary"
            >风机导入</ct-button
          >
          <div class="bar"></div>
          <ct-button :btnClick="downloadTemplate">模板下载</ct-button>
        </div>
      </div>
    </modal>
    <el-dialog
        v-drag:common
        title="修改机型"
        :visible="showProjectTurbineType"
        :show-close="false"
        width="400px"
        :append-to-body= 'true'
    >
      <div style="text-align: center;padding:0 0 15px 0">
        机型：
        <el-select v-model="projectTurbineTypeValue" placeholder="请选择">
          <el-option
              v-for="item in turbineTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>

      <div slot="footer" class="dialog-footer">
        <ct-button :btn-click="clearProjectTurbineType" size="small" style="margin-right: 10px"
        >取 消</ct-button
        >
        <ct-button type="primary" :btn-click="trueProjectTurbineType" size="small"
        >确 定</ct-button
        >
      </div>
    </el-dialog>
    <LayoutUploadModal
            :visible="layoutModalVisible"
            @close="layoutModalVisible = false"
            @uploadConfirm="handleLayoutSuccess"
    ></LayoutUploadModal>
  </MyModal>
</template>

<script>
import MyModal from './modal';
import turbineIconSelect from '../images/turbine-select.png';
import StandInput from './stand-input';
import LayoutUploadModal from './layoutUploadDialog.vue';
import {
  toFixed,
  parseMapDataToGeoInfo,
  booleanPointInPolygon,
} from '../utils';
import loadingMask from '@/components/loading-mask';
import { getToken } from '@/utils';
import { mapGetters } from 'vuex';
import L from 'leaflet';
import { hasPermission } from '@/permission/index';
import { getTurbineList, updateFengji } from '../service';
export default {
  components: {
    MyModal,
    StandInput,
    LayoutUploadModal
  },
  computed: {
    ...mapGetters('WindFarm', [
      'toolUIStatus',
      'boosterList',
      'projectList',
      'specificDragFlag',
      'dataSet',
    ]),
    activeName() {
      return this.tabList.find(i => i.active).name;
    },
    extraData() {
      return {
        planId: this.$route.query.planId,
        apiKey: getToken(),
      };
    },
    projectTurbineType(){
      const _this = this;
      const item = this.turbineTypeList.find(i => i.value == _this.autoTurbineParam.turbineTypeLimit);
      return item.label
    }
  },
  data() {
    return {
      isExportTurbine: false,
      layoutModalVisible: false,
      curRow: {},
      exclusiveList: [],
      turbineHubHeight: null,
      turbineList: [],
      isBootEdit: false,
      advanced: true,
      fileList: [],
      file: null,
      action: `${process.env.VUE_APP_API_HOST}/windfarm/windfarm/uploadTurbineFile`,
      uploadForm: {
        uploadFileName: '',
      },
      uploadrules: {
        uploadFileName: [
          { required: true, message: '请上传风机文件', trigger: 'change' },
        ],
      },
      showImportWindFarmDialog: false,
      manualFengjiList: [],
      tabList: [
        {
          name: '自动布机',
          active: true,
        },
        {
          name: '手动布机',
          active: false,
        },
      ],
      rowItemList: [
        {
          label: '机型',
          key: 'turbineTypeLimit',
          value: 0,
          multiple: false,
          unit: '',
          onlyNumber: false,
          type: 'select',
          selectOptions: [],
          place: 1,
        }
      ],
      seniorItemList: [
        {
          label: '长轴间距',
          key: 'longAxisDistance',
          value: null,
          unit: 'D',
          onlyNumber: true,
          type: 'input',
        },
        {
          label: '短轴间距',
          key: 'shortAxisDistance',
          value: null,
          unit: 'D',
          onlyNumber: true,
          type: 'input',
        },
        {
          label: '长轴方位',
          key: 'longAxisAngle',
          // key: 'longAxisDistance',
          value: null,
          unit: '°',
          onlyNumber: true,
          max: 360,
          type: 'input',
        },
        {
          label: '排布方式',
          key: 'deployType',
          value: null,
          type: 'select',
          selectOptions: [
            { label: '自由排布', value: 1 },
            { label: '规则排布', value: 2 },
          ],
        },
        {
          label: '风速高度',
          key: 'level',
          value: null,
          onlyNumber: true,
          interger: true,
          type: 'select',
          selectOptions: [],
        },
        {
          label: '最小平均风速',
          key: 'wspd',
          value: null,
          onlyNumber: true,
          type: 'input',
          unit: 'm/s',
        },

        {
          label: '最大地形坡度',
          key: 'maxSlope',
          value: null,
          unit: '%',
          onlyNumber: true,
          interger: true,
          type: 'input',
        },
        {
          label: '边界距离',
          key: 'boundaryDistance',
          value: null,
          unit: 'm',
          onlyNumber: true,
          interger: true,
          type: 'input',
        },

        {
          label: '机组数量',
          key: 'cap',
          value: null,
          onlyNumber: true,
          interger: true,
          type: 'input',
          unit: '台',
          marginLeft: '0px',
          place: 2,
        },
        {
          label: '容量',
          key: 'capTheoretical',
          value: null,
          onlyNumber: true,
          interger: true,
          type: 'input',
          unit: 'MW',
          readonly: true,
        },
      ],
      limitList: [],
      turbineTypeList: [],
      autoTurbineParam: {
        maxSlope: null,
        turbineCount: null,
        maxAltitude: null,
        turbineType: null,
        turbineTypeId: null,
        turbineHeight: null,
        turbineDistance: null,
      },
      manualTypeList: [],
      manualTurbineParam: {
        turbineTypeId: null,
        turbineHeight: null,
      },
      store: null,
      reselect: 0,
      loading: false,

      projectTurbineTypeValue: null,
      showProjectTurbineType: false,
      gridData:[{
        turbineNo: 'F001',
        lon: 121.8,
        lat: 31.2,
      },{
        turbineNo: 'F002',
        lon: 121.45,
        lat: 31.3667,
      }]
    };
  },
  created() {
    this.$bus.$on('createShengyazhan', this.addBooster);
    this.$bus.$on('createLimitAdd', this.addExclusive);
    this.$bus.$on('createfengji', this.createfengji);
    this.$bus.$on('updateTurbineLocation', this.updateTurbineLocation);
    // this.$store.commit('WindFarm/SET_FENGJIBIANHAOFLAG', true);
    // setTimeout(() => {
    //   if (this.hasPerms('layer-landWspd')) {
    //     this.$bus.$emit('checkLayer', ['fengziyuan']);
    //   }
    //   this.$bus.$emit('checkLayer', 'tiandi');
    // });
  },
  beforeDestroy() {
    this.$bus.$off('createShengyazhan', this.addBooster);
    this.$bus.$off('createLimitAdd', this.addExclusive);
    this.$bus.$off('createfengji', this.createfengji);
    this.$bus.$off('updateTurbineLocation', this.updateTurbineLocation);
    this.cancelCreateFengji(false);
    this.$store.commit('WindFarm/SET_specificDragFlag', false);
    this.$store.commit('WindFarm/SET_FENGJIBIANHAOFLAG', true);
    // this.handleCancelFjResult();
  },
  async mounted() {
    //   if (this.projectList.length <= 0) {
    //   this.$router.push({
    //     name: 'project-list',
    //     query: {
    //       projectId: this.$route.query.projectId,
    //       projectName: this.$route.query.projectName,
    //     },
    //   });
    //   return;
    // }
    // this.$store.commit('WindFarm/UPDATE_TUILIST');
    // this.queryLimitList();
    this.fetchTurbineList();
    await this.queryAutoParams();
    await this.queryTurbineType();
    //获取手动布机参数
    // this.queryManualParams();

    // this.handleAdjustClick();
  },
  watch: {
    reselect: {
      handler(val) {
        if (val === 1) {
          this.handleDeployCap();
        }
      },
    },
    dataSet: {
      handler(val) {
        if (val) {
          this.seniorItemList[4].selectOptions = val?.[0]?.datasetHeight?.map(
            (v) => ({ label: v, value: v })
          );
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ediProjectTurbineType(){
      this.projectTurbineTypeValue = this.autoTurbineParam.turbineTypeLimit;
      this.showProjectTurbineType = true;
    },
    trueProjectTurbineType(){
      const _this = this;
      this.$postForm('/windfarm/station/setPlanTurbineType', {
        showSuccess: true,
        showError: true,
        data: {
          planId: this.$route.query.planId,
          turbineTypeId: this.projectTurbineTypeValue
        },
      }).then(() => {
        this.queryAutoParams();
        this.clearProjectTurbineType();
      });
    },
    clearProjectTurbineType(){
      this.projectTurbineTypeValue = null;
      this.showProjectTurbineType = false;
    },
    hasPerms(perms) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(perms);
    },
    changeCap(val, item) {
      item.value = val;
      if (item.key === 'shear') {
        let turbineTypeLimit = this.rowItemList.find(
          (i) => i.key === 'turbineTypeLimit'
        ).value;
        this.$fetch('windfarm/station/getNewHubHeight', {
          showError: true,
          params: {
            shear: val,
            turbineTypeLimit: turbineTypeLimit || 0,
            projectId: this.$route.query.projectId,
          },
        }).then((res) => {
          const { hubHeight } = res.data;
          this.rowItemList.forEach((item) => {
            if (item.key === 'hubHeight') {
              item.value = hubHeight;
            }
          });
        });
        //     } else if (item.key === 'turbineTypeLimit') {
        // let shear = this.seniorItemList.find(i => i.key === 'shear').value;
        // this.$fetch('windfarm/station/getNewHubHeight', {
        //   showError: true,
        //   params: {
        //     turbineTypeLimit: val,
        //     shear: shear || 0,
        //     projectId: this.$route.query.projectId
        //   }
        // }).then(res => {
        //   const { hubHeight } = res.data;
        //   this.rowItemList.forEach(item => {
        //     if (item.key === 'hubHeight') {
        //       item.value = hubHeight;
        //     }
        //   });
        // });
      } else if (
        [
          //不联动 所以先注释
          // 'turbineTypeLimit',
          // 'boundaryDistance',
          // 'longAxisAngle',
          // 'longAxisDistance',
          // 'maxSlope',
          // 'shortAxisDistance',
          // 'wspd',
        ].includes(item.key)
      ) {
        const currentFormData = this.seniorItemList.reduce((acc, cur) => {
          acc[cur.key] = cur.value;

          return acc;
        }, {});

        const anotherCurrentFormData = this.rowItemList.reduce((acc, cur) => {
          acc[cur.key] = cur.value;

          return acc;
        }, {});

        this.$fetch('/windfarm/station/getNewCapByWspd', {
          showError: true,
          showSuccess: true,
          params: {
            ...currentFormData,
            ...anotherCurrentFormData,
            planId: this.$route.query.planId,
            // turbineTypeLimit: turbineTypeLimit || 0
          },
        }).then((res) => {
          const { cap, capTheoretical } = res.data;
          this.seniorItemList.forEach((item) => {
            if (item.key === 'cap') {
              item.value = cap;
            }
            if (item.key === 'capTheoretical') {
              item.value = capTheoretical;
            }
          });
        });
      }
    },
    refreshCalc() {
      const currentFormData = this.seniorItemList.reduce((acc, cur) => {
        acc[cur.key] = cur.value;

        return acc;
      }, {});
      this.loading = true;
      const anotherCurrentFormData = this.rowItemList.reduce((acc, cur) => {
        acc[cur.key] = cur.value;

        return acc;
      }, {});

      this.$fetch('/windfarm/station/getNewCapByWspd', {
        showError: true,
        showSuccess: true,
        params: {
          ...currentFormData,
          ...anotherCurrentFormData,
          planId: this.$route.query.planId,
          // turbineTypeLimit: turbineTypeLimit || 0
        },
      }).then((res) => {
        const { cap, capTheoretical } = res.data;
        this.seniorItemList.forEach((item) => {
          if (item.key === 'cap') {
            item.value = cap;
          }
          if (item.key === 'capTheoretical') {
            item.value = capTheoretical;
          }
        });
        this.loading = false;
      });
    },
    handleDeployCap() {
      this.$confirm(
        '容量规划模块参数更新，是否需要根据最新参数部署机组',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        this.handleDeployClick(1);
      });
    },
    handleEditBoClick(data) {
      this.isBootEdit = true;

      //console.log(data);
      this.store = {
        lat: data.lat,
        lon: data.lon,
      };
    },
    handleCancelBoClick(data) {
      data.lat = this.store.lat;
      data.lon = this.store.lon;
      this.isBootEdit = false;
    },
    handleSaveBoClick(data) {
      this.$bus.$emit('getWindScopeData', (map) => {
        const poly = map.map((item) => [item.lat, item.lng]);
        const result = booleanPointInPolygon([data.lat, data.lon], [poly]);

        if (!result) {
          return this.$message.warning('升压站必须在风场内部');
        }

        this.$postForm('/windfarm/windfarm/saveBooster', {
          showError: true,
          showSuccess: true,
          data: {
            lat: data.lat,
            lon: data.lon,
            planId: this.$route.query.planId,
          },
        }).then(() => {
          this.handleShengyaAddClick(false);
          this.queryBoosterList();
          this.isBootEdit = false;
        });
      });
    },
    handleTriImport() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const formData = new FormData();
          formData.append('file', this.file?.raw);
          formData.append('apiKey', getToken());
          formData.append('planId', this.$route.query.planId);

          this.$fetch({
            method: 'POST',
            url: 'windfarm/windfarm/uploadTurbineFile',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            noJudge: true,
          }).then((res) => {
            const { code } = res.data;

            if (code == 0) {
              this.aswitch = loadingMask({ mask: true });
              this.$refs.upload.submit();
            }
          });
        }
      });
    },
    downloadTemplate() {
      window.open(
        `${process.env.VUE_APP_API_HOST}/windfarm/project/getTemplateFile?fileName=turbineInfoFile.xlsx`,
        '_parent'
      );
    },
    uploadErrorCb() {
      this.file = null;
      this.showImportWindFarmDialog = false;
      this.$refs.form.resetFields();

      this.aswitch && this.aswitch.close();
    },
    uploadSuccessCb(res) {
      const { code, message } = res;
      this.aswitch && this.aswitch.close();
      this.fileList = [];
      this.uploadForm.uploadFileName = '';

      this.$refs.form.resetFields();
      this.file = '';

      this.$refs.upload.clearFiles();
      if (code === 0) {
        this.showImportWindFarmDialog = false;
        this.$message({
          message: message,
          type: 'success',
        });
        this.uploadForm.uploadFileName = '';

        this.$store.dispatch('WindFarm/getWindfarmTurbineList', {
          params: {
            planId: this.$route.query.planId,
          },
        });

        // 更新道路
        // this.$store.dispatch('WindFarm/getRoadList', {
        //   params: {
        //     planId: this.$route.query.planId
        //   }
        // });

        // 成功后做的事情
        // this.$bus.$emit('updateWindFarmAndItems', {
        //   type: 'windFarm',
        //   data: windfarm
        // });
      } else {
        this.$message({
          message: message,
          type: 'error',
        });
      }
    },
    handleUploadChange(file, fileList) {
      if (!fileList.length) {
        this.file = null;
        this.uploadForm.uploadFileName = '';
      } else {
        this.file = file;
        this.uploadForm.uploadFileName = file?.name;
        this.fileList = [file];
      }

      // this.fileList = fileList;
      // this.file = null;
      // this.uploadForm.uploadFileName = '';
    },
    importDialogClose() {
      this.uploadForm.uploadFileName = '';
    },
    handleAdjustClick() {
      if (this.toolUIStatus['fengji']) {
        return this.$message.warning('正在添加风机，不可进行调整');
      }

      this.$nextTick(() => {
        this.$bus.$emit('resultClickFj');
      });
    },
    handleCancelFjResult() {
      this.$nextTick(() => {
        this.$bus.$emit('resultClickFj');
      });
    },

    handleSaveRoadClick() {
      this.$bus.$emit('roadSaveClick');
    },

    cancelCreateFengji(value) {
      // this.$store.commit('WindFarm/UPDATE_TUILIST');
      this.$bus.$emit('updateTurList');
      this.handleAddFengji(value);
      this.manualFengjiList = [];
    },
    toFixed,
    handleCloseModalClick() {
      this.$bus.$emit('farmClick', 0);
      // this.$bus.$emit('farmClick', 0);
    },
    handleSaceFengjiClick() {
      // const myItem = this.manualTypeList.find(
      //   (item) => item.label === this.manualTurbineParam.turbineType
      // );

      // if (!myItem) {
      //   return this.$message.warning(
      //     `机型${this.manualTurbineParam.turbineType}已经从机型库删除，请重新选择机型`
      //   );
      // }

      // this.manualTurbineParam.turbineTypeId = myItem.id;

      if (!this.manualFengjiList.length) {
        return this.$message.warning('请添加风机');
      }

      const lat = this.manualFengjiList.map(i => i.data.lat).join(',');
      const lon = this.manualFengjiList.map(i => i.data.lon).join(',');
      this.$postForm('/windfarm/station/addTurbineByPlanId', {
        data: {
          planId: this.$route.query.planId,
          lat,
          lon,
        },
        showSuccess: true,
        showError: true,
        showLoading: true,
      }).then(() => {
        this.$bus.$emit('updateTurList');

        this.fetchTurbineList();

        this.manualFengjiList = [];

        this.handleAddFengji(false);
      });

    },
    handleImportClick() {
      if(this.turbineList.length == 0){
        this.layoutModalVisible = true;
      }else{
        this.$confirm(
                '重复导入将会覆盖原有数据',
                '提示',
                {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning',
                }
        ).then(() => {
          this.layoutModalVisible = true;
        });
      }
    },
    handleLayoutSuccess(){
      this.layoutModalVisible = false;
      this.$bus.$emit('updateTurList');
      this.$bus.$emit('updateTowerList');
      this.$bus.$emit('updatePlanToolIconStatus')
      this.fetchTurbineList()
      this.queryAutoParams();
    },
    handleDeployClick(reselect) {
      const params = this.rowItemList.reduce((acc, cur) => {
        const key = cur.key;
        const value = cur.value;
        acc[key] = value;
        return acc;
      }, {});
      const seniorParams = this.seniorItemList.reduce((acc, cur) => {
        const key = cur.key;
        const value = cur.value;
        acc[key] = value;
        return acc;
      }, {});

      // delete params.turbineType;
      //限制区域
      let geometryInfos = null;
      geometryInfos = this.exclusiveList.map(i => i.geometryInfo).join(';');
      //避让距离
      this.$postForm('/windfarm/station/selectionStartDeployTurbine', {
        data: {
          ...params,
          ...seniorParams,
          geometryInfos,
          reselect: reselect || 0,
          // avoidDiatances: this.exclusiveList
          //   .map(i => i.avoidDiatance)
          //   .join(','),
          planId: this.$route.query.planId,
          projectId: this.$route.query.projectId,
        },
        showError: true,
        showSuccess: true,
        showLoading: {
          mask: true,
          loadingContent:
            '自动排布过程结合地形、风资源、面积等数据，运用人工智能算法，对风机进行合理排布，以达到最优风场收益',
        },
      }).then((res) => {
        if (res.code === 0) {
          this.$bus.$emit('updateTurList');
          this.$bus.$emit('updateTowerList');
          this.$bus.$emit('updatePlanToolIconStatus')
          this.fetchTurbineList()
          this.queryAutoParams();
        }
      });
    },
    fetchTurbineList() {
      getTurbineList(this.$route.query.planId).then((res) => {
        const { data } = res;
        const { turbineList } = data;

        this.turbineList = turbineList.map((v) => {
          return {
            inputLatName: v.lat,
            edit: false,
            inputLonName: v.lon,
            ...v,
            isShow: true,
          };
        });

      });
    },
    handleViewSyzClick(item, index) {
      const newArr = this.boosterList;
      const { isShow } = item;
      newArr[index].isShow = !isShow;
      this.$store.commit('WindFarm/SET_BOOSTERLIST', newArr);
      this.$store.commit('WindFarm/UPDATE_BOOST_AREA', newArr);
    },
    handleViewClick(item, index) {
      const newArr = this.exclusiveList;

      const { isShow } = item;
      newArr[index].isShow = !isShow;
      this.$store.commit('WindFarm/SET_EXCLUSIVELIST', newArr);
      this.$store.commit('WindFarm/UPDATE_LIMIT_AREA', newArr);
    },
    addExclusive(data) {
      const str = parseMapDataToGeoInfo(data, 'Polygon');
      const i = {
        avoidDiatance: 0,
        geometryInfo: str,
        isShow: true,
        insertIndex: parseInt(Math.random() * 1000000),
      };
      this.exclusiveList.push(i);
      this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
      this.$store.commit('WindFarm/SET_EXCLUSIVELIST', this.exclusiveList);
      this.$store.commit('WindFarm/UPDATE_LIMIT_AREA');
      // this.$postForm('/windfarm/windfarm/saveWindfarmExclusive', {
      //   data: {
      //     geometryInfo: str,
      //     planId: this.$route.query.planId
      //   },
      //   showError: true,
      //   showSuccess: true
      // })
      //   .then(() => {
      //     this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
      //     this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
      //
      //     this.$store.dispatch('WindFarm/getWindfarmExclusive', {
      //       params: {
      //         planId: this.$route.query.planId
      //       }
      //     });
      //   })
      //   .catch(() => {
      //     this.$store.commit('WindFarm/POP_MAPDATA_POLYGONS');
      //   });
    },
    applyTur() {
      this.$postForm('/windfarm/windfarm/fullTurbineSet', {
        showError: true,
        showSuccess: true,
        params: {
          turbineTypeId: this.manualTurbineParam.turbineTypeId,
          planId: this.$route.query.planId,
        },
      }).then(() => {
        // TODO 请求风机
      });
    },
    applyHeight() {
      this.$postForm('/windfarm/windfarm/fullHeightSet', {
        showError: true,
        showSuccess: true,
        params: {
          height: this.manualTurbineParam.turbineHeight,
          planId: this.$route.query.planId,
        },
      }).then(() => {
        // TODO 请求风机
      });
    },
    queryManualParams() {
      this.$fetch('/windfarm/windfarm/getManualTurbineParam', {
        showError: true,
        params: {
          planId: this.$route.query.planId,
        },
      }).then((res) => {
        const { data } = res;
        const { turbineTypeList = [], manualTurbineParam = {} } = data;

        this.manualTypeList = turbineTypeList.map(i => {
          return {
            label: i.turbineType,
            value: i.turbineType,
            id: i.turbineTypeId,
          };
        });
        this.manualTurbineParam = manualTurbineParam;
      });
    },
    async queryAutoParams() {
      this.$fetch('/windfarm/station/getWindfarmPlanParam', {
        showError: true,
        params: {
          planId: this.$route.query.planId,
        },
      }).then((res) => {
        const { data } = res;
        const { turbineParam, exclusiveList } = data;
        this.autoTurbineParam = turbineParam;
        this.rowItemList.forEach((item) => {
          item.value = this.autoTurbineParam[item.key];
        });
        this.turbineHubHeight = this.autoTurbineParam['turbineHubHeight'];
        this.seniorItemList.forEach((item) => {
          item.value = this.autoTurbineParam[item.key];
        });
        if (exclusiveList) {
          this.exclusiveList = exclusiveList.map(i => {
            return {
              ...i,
              isShow: true,
              insertIndex: parseInt(Math.random() * 1000000),
            };
          });
        }
        this.reselect = turbineParam.reselect;
        // this.$store.commit('WindFarm/SET_EXCLUSIVELIST', this.exclusiveList);
        // this.$store.commit('WindFarm/UPDATE_LIMIT_AREA');
      });
    },
    async queryTurbineType() {
      //获取风机类型
      this.$fetch('/windfarm/station/getTurbineTypeList', {
        params: {
          projectId: this.$route.query.projectId,
        },
        showError: true,
      }).then((res) => {
        const { data } = res;
        const { turbineTypeList } = data;

        const selectTypeItem = this.rowItemList.find(i => i.label === '机型');
        if (!selectTypeItem.value) {
          this.$set(selectTypeItem, 'value', turbineTypeList[0].turbineTypeId);
        }

        this.turbineTypeList = turbineTypeList.map(i => {
          return {
            label: i.turbineType,
            value: i.turbineTypeId,
            markFlag: i.markFlag,
            id: i.turbineTypeId,
          };
        });

        this.$set(selectTypeItem, 'selectOptions', this.turbineTypeList);
      });
    },
    addBooster(data) {
      const { lat, lng: lon } = data;

      this.$bus.$emit('getWindScopeData', (map) => {
        const poly = map.map((item) => [item.lat, item.lng]);
        const result = booleanPointInPolygon([lat, lon], [poly]);

        if (!result) {
          this.$store.commit('WindFarm/POP_MAP_POINT');
          return this.$message.warning('升压站必须在风场内部');
        }
        this.$postForm('/windfarm/windfarm/saveBooster', {
          showError: true,
          showSuccess: true,
          data: {
            lat,
            lon,
            planId: this.$route.query.planId,
          },
        })
          .then(() => {
            this.$store.commit('WindFarm/POP_MAP_POINT');
            this.handleShengyaAddClick(false);

            this.queryBoosterList();
          })
          .catch(() => {
            this.$store.commit('WindFarm/POP_MAP_POINT');
          });
      });
    },

    validateFengji(params, success = () => {}) {
      this.$postForm('/windfarm/windfarm/fanGroupCheck', {
        data: {
          ...params,
          planId: this.$route.query.planId,
        },
        showLoading: true,
        noJudge: true,
      }).then((re) => {
        const res = re.data;

        const { code, message } = res;

        if (code == 0) {
          success();
        }

        if (code == 1) {
          return this.$message.error(message);
        }

        if (code == 2) {
          this.$confirm(message, '提醒', {
            confirmButtonText: '继续保存',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            success();
          });
        }
      });
    },

    createfengji(data) {
      const { lat, lng: lon } = data;

      this.manualFengjiList.push({
        data: {
          lat,
          lon,
        },
      });
    },
    queryBoosterList() {
      this.$store.dispatch('WindFarm/getBoosterList', {
        params: {
          planId: this.$route.query.planId,
        },
      });
    },
    queryLimitList() {
      this.$fetch('/windfarm/windfarm/getWindfarmExclusive', {
        showError: true,
        params: {
          planId: this.$route.query.planId,
        },
      }).then((res) => {
        const { data = {} } = res || {};
        let { windfarmExclusiveList = [] } = data;

        if (!windfarmExclusiveList) {
          windfarmExclusiveList = [];
        }

        this.limitList = windfarmExclusiveList;
      });
    },
    handleTabClick(item) {
      this.tabList.forEach(i => {
        if (i !== item) {
          i.active = false;
        } else {
          i.active = true;
        }
      });
    },
    handleAddFengji(value) {
      if (value) {
        this.handleCancelFjResult();
      } else {
        this.$nextTick(() => {
          this.$bus.$emit('resultClickFj');
        });
      }

      let status;

      if (value !== undefined) {
        status = !value;
      } else {
        status = this.toolUIStatus['fengji'];
      }

      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
      this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
        key: 'fengji',
        value: !status,
      });

      this.$bus.$emit('getMapInstance', (map) => {
        map.setDefaultIcon(
          L.icon({
            iconUrl: turbineIconSelect,
            iconSize: [25, 25],
            iconAnchor: [13, 25],
          })
        );
      });

      this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
        key: 'drawMarker',
        value: !status,
      });
    },
    handleLimitClick(value) {
      let status;

      if (value !== undefined) {
        status = !value;
      } else {
        status = this.toolUIStatus['limitAdd'];
      }

      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
      this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
        key: 'limitAdd',
        value: !status,
      });

      this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
        key: 'drawPolygon',
        value: !status,
      });
    },
    handleDelLimitClick(item, index) {
      this.exclusiveList.splice(index, 1);
      this.$store.commit('WindFarm/SET_EXCLUSIVELIST', this.exclusiveList);
      this.$store.commit('WindFarm/UPDATE_LIMIT_AREA');
    },
    handleDelBoostClick() {
      this.$confirm(`是否删除该升压站`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$postForm('/windfarm/windfarm/deleteBooster', {
          showSuccess: true,
          showError: true,
          data: {
            planId: this.$route.query.planId,
          },
        }).then(() => {
          this.queryBoosterList();
        });
      });
    },
    handleShengyaAddClick(value) {
      let status;

      if (value !== undefined) {
        status = !value;
      } else {
        status = this.toolUIStatus['shengyazhanAdd'];
      }

      this.$store.commit('WindFarm/RESET_UI_AND_BAR_STATUS');
      this.$store.commit('WindFarm/SET_TOOL_UI_STATUS', {
        key: 'shengyazhanAdd',
        value: !status,
      });

      this.$bus.$emit('getMapInstance', (map) => {
        map.setDefaultIcon(
          L.icon({
            iconUrl: require('../images/shengyazhan.png'),
            iconSize: [20, 20],
            iconAnchor: [10, 20],
          })
        );
      });

      this.$store.commit('WindFarm/SET_TOOL_BAR_STATUS', {
        key: 'drawMarker',
        value: !status,
      });
    },
    updateTurbineItem(turbine) {
      updateFengji({
        lat: turbine.inputLatName,
        lon: turbine.inputLonName,
        turbineId: turbine.turbineId,
      }).then(() => {
        this.fetchTurbineList();
        this.$bus.$emit('updateTurList');
        // this.$bus.$emit('updateTowerList');
      });
    },
    deleteTurbineItem(item) {
      this.$confirm('是否删除该风机', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$postForm('/windfarm/station/deleteTurbine', {
          showSuccess: true,
          showError: true,
          data: {
            turbineId: item.turbineId,
          },
        }).then(() => {
          this.fetchTurbineList();
          this.$bus.$emit('updateTurList');
        });
      });
    },
    handleExportTurbine(){
      if(this.isExportTurbine){
        return false;
      }
      this.isExportTurbine = true;
      const apiKey = getToken();
      // const loading = this.$loading({
      //   text: '正在导出风机，请稍后...',
      //   spinner: 'el-icon-loading',
      // });

      this.$fetch(`/windfarm/station/exportTurbineList?apiKey=${apiKey}&planId=${this.$route.query.planId}`, {
        method: 'post',
        showError: true,
        // showLoading: {
        //   mask: true,
        //   loadingContent: '正在下载请稍后'
        // },
        noJudge: true,
        responseType: 'blob',
      })
        .then(res => {
          if(res.status == 401){
            this.errorMessage(res.data);
            return;
          }
          if(res.status == 402){
            this.$message.error("数据正在准备中，请稍后再试");
            return;
          }
          const blob = new Blob([res.data]);

          var link = document.createElement('a');
          var fileURL = URL.createObjectURL(blob);
          link.target = '_blank';
          link.href = fileURL;
          link.download = '风机列表.csv'; //文件名称
          link.click();
          // loading.close();
          this.isExportTurbine = false;
        })
        .catch(() => {});
    },
    async errorMessage(data){
      const text = await data.text(); // 将 Blob 转为文本
      this.$message.error(text);
    },
    rowClick(row){
      this.curRow = row;
      this.$bus.$emit('showTurbineDetail',row.turbineId,row.edit);
    },
    updateTurbineLocation(turbine){
      this.turbineList = this.turbineList.map((v) => {
        if(v.turbineId == turbine.id){
            v.inputLatName = turbine.lat;
            v.lat = turbine.lat;
            v.edit = true;
            v.inputLonName = turbine.lng;
            v.lon = turbine.lng;
            v.isShow =  true;
        }
        return v;
      });
    }
  },
};
</script>

<style lang="less" scoped>
::v-deep.wind-farm-modal-wrapper .content{
  overflow-y: auto;
}
.i-con{
  color:#1890ff;
  font-size: 14px;
  padding:0 0 0 8px;
  cursor: pointer;
}
.adjust-desc-click {
  position: absolute;
  width: 320px;
  margin-right: 120px;
  margin-top: 8px;
  font-weight: 800;
  color: #ff8b24;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mr-10 {
  margin-right: 5px;
}
.width-40 {
  font-size: 12px;
  height: 100%;
  width: 60px;
}
.my-btn-warpper {
  display: flex;
  padding: 15px 10px;
  text-align: right;
  flex-direction: row-reverse;

  .ct-btn:last-child {
    margin-right: 10px;
  }
}
.upload-demo {
  height: 28px;
  .click-area {
    .file-name {
      width: 300px;
      height: 28px;
      border-radius: 7px;
      padding-left: 10px;
      text-align: left;
      margin-right: 20px;
      background-color: #fff;
      border: 2px solid #d9e6f3;
    }
    display: flex;
    justify-content: space-between;
  }
}
.el-icon-warning-outline {
  color: #4f4f4f;
}

.desc-tooltip {
  position: absolute;
  left: 25%;
  top: 15px;
  &::before {
    content: url('../images/tootip-desc.png');
  }
}
.shear-tooltip {
  margin-left: 10px;
  &::before {
    content: url('../images/tootip-desc.png');
  }
}
.my-content {
  padding: 10px 0 0 0;
  .adjust-desc-new {
    margin-top: 10px;
    font-weight: 800;
    color: #ff8b24;
    font-size: 14px;
    line-height: 20px;
  }
  .core {
    justify-content: space-between;
    // background-color: #fff;
    border-radius: 7px;
    display: flex;
    // padding: 10px;
    .tab {
      //user-select: none;
      display: flex;
      align-items: center;
      .tab-item {
        height: 28px;
        width: 85px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        border: 2px solid #0877be;
        cursor: pointer;
        &:first-child {
          border-radius: 5px 0px 0px 5px;
        }
        &:last-child {
          border-radius: 0px 5px 5px 0px;
        }
        &.is-active {
          background-color: #0877be;
          color: #fff;
        }
      }
    }
  }
  .deploy-content {
    padding: 0 10px;
    color: @black-color;
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    .row-item {
      display: inline-block;
      //padding-left: 10px;
      width: 190px;
      margin-bottom: 5px;
      &.special {
        margin-left: 0px !important;
      }
      &.place {
        width: 100%;
        margin-left: 0px;
        &:nth-child(2n) {
          margin-left: 10px;
        }
        &:nth-child(2n + 1) {
          margin-right: 10px;
        }
        .row-item-core {
          display: flex;
          align-items: center;
          .key {
            margin-right: 5px;
            width: 78px;
            font-weight: 400;
            font-size: 13px;
          }
          .value {
            width: 300px;
          }
        }
      }
      &:nth-child(2n + 1) {
        margin-left: 0px;
      }
      &:nth-child(2n) {
        margin-left: 10px;
      }
      .row-item-core {
        display: flex;
        align-items: center;
        .key {
          margin-right: 5px;
          min-width: 84px;
          padding-left: 5px;
          font-weight: 400;
          font-size: 12px;
        }
        .value {
          min-width: 95px;
          font-size: 12px;
        }
      }
    }
  }

  .adjust-area {
    margin-top: 10px;
    text-align: right;
    .ct-btn {
      margin-left: 5px;
    }
  }

  .manual-row {
    margin-bottom: 10px;
    display: flex;
    align-content: center;
    .key {
      margin-right: 5px;
      width: 60px;
      line-height: 30px;
      font-weight: 400;
      font-size: 13px;
    }
    .value {
      width: 220px;
    }
    .el-btn-wrapper {
      margin-left: 10px;
    }
  }

  .deploy-btn-row {
    display: flex;
    justify-content: space-between;
    color: @black-color;
  }
  .deploy-btn-wrapper {
    text-align: center;
    display: flex;
    align-items: center;
    margin: 5px 0 10px 0;
  }
  .add-fengji-wrapper {
    text-align: right;
    margin-top: 10px;
  }

  .add-fengji {
    display: inline-block;
    i {
      cursor: pointer;
      &:hover {
        color: #478beb;
      }
      &.is-active {
        color: #0159ac;
      }
    }
    font-weight: normal;
    font-size: 16px;
    color: #000;
    position: relative;
    .ct-btn {
      margin-left: 5px;
    }
  }

  .adjust-desc {
    position: relative;
    left: -15px;
    font-size: 14px;
    font-weight: bold;
  }

  .limit-area,
  .shengyazhan-area {
    margin-top: 10px;
    .my-title {
      font-weight: normal;
      font-size: 16px;
      color: #000;
      padding: 0px 10px;
      position: relative;
      &::before {
        content: '';
        display: block;
        position: absolute;
        left: 0px;
        top: 0px;
        border-radius: 3px;
        width: 3px;
        height: 100%;
        background-color: #409eff;
      }
      i {
        cursor: pointer;
        &:hover {
          color: #478beb;
        }
        &.is-active {
          color: #0159ac;
        }
      }
    }
    .area-content {
      margin-top: 10px;
      padding: 0px 10px;
      max-height: 120px;
      overflow: auto;
    }
    .depoly-content-item {
      .el-tag {
        color: #537dfc;
        background: rgba(83, 125, 252, 0.2);
        border: 1px solid #537dfc;
        box-sizing: border-box;
        border-radius: 2px;
      }
      &:nth-child(n + 1) {
        margin-top: 5px;
      }
      display: flex;
      align-items: center;
      position: relative;
      & > span {
        display: flex;
        align-items: center;
      }

      .btns {
        display: flex;
        align-items: center;
        position: absolute;
        right: 0;
        i {
          display: flex;
          align-items: center;
          cursor: pointer;

          &.is-active {
            color: #3cc2e6;
          }
          &:hover {
            color: #478beb;
          }
          &:nth-child(n + 2) {
            margin-left: 10px;
          }
        }
      }
    }
  }
}
.refresh {
  position: relative;
  top: -40px;
  right: -35px;
  color: #1890ff;
  cursor: pointer;
}

.popover-content{
  font-size: 12px;
}
.popper{
  background: white;
}
.icon{
  color:#999999;
  font-size: 16px;
  font-weight: normal;
  cursor: pointer;
}

/deep/ .el-table .cell{
  padding-left: 5px;
  padding-right: 5px;
}
/deep/ .el-table th.el-table__cell>.cell{
  padding-left: 5px;
  padding-right: 5px;
  line-height: 28px;
}
/deep/ .el-table--mini .el-table__cell{
  padding: 2px 0;
}
/deep/ .el-table .el-input__inner{
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  padding: 0 2px;
}
/deep/ .el-button--text{
  padding-left: 1px;
  padding-right: 1px;
}
</style>
